import { backgroundTokens, colors } from '@ardoq/design-tokens';
import styled from 'styled-components';
import { GraphBackground, GraphViewProps } from './props';
import { useYFiles } from './useYFiles';

const Container = styled.div<{ $background: GraphBackground }>`
  width: 100%;
  height: 100%;

  background: ${({ $background }) =>
    $background === 'dotted' ? backgroundTokens.dotted : 'none'};

  &:has(:focus-visible) {
    box-shadow: inset 0 0 0 2px ${colors.blue700};
  }
`;

export const GraphView = ({
  background = 'dotted',
  ...props
}: GraphViewProps) => {
  const { containerRef } = useYFiles(props);

  return <Container ref={containerRef} $background={background} />;
};
